import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import type { ProductFormValues } from "@/types/product-type";
import { productSchema } from "@/types/product-type";
import { useCreateProduct } from "@/services/product-service";
import { CreateProductWizard } from "@/pages/product/components/create-product-wizard";

export default function CreateProductPage() {
  const createProductMutation = useCreateProduct();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const form = useForm<ProductFormValues>({
    resolver: zodResolver(productSchema),
    mode: "onChange",
    defaultValues: {
      code: "",
      name: "",
      description: "",
      unit: "",
      price: 0,
      cost: 0,
      initStock: 0,
      imageUrl: "",
      isActive: true,
      onStoreFront: false,
      categoryId: null,
      colorValues: [],
      sizeValues: [],
    },
  });

  const handleSubmit = async (values: ProductFormValues) => {
    setIsSubmitting(true);
    try {
      await createProductMutation.execute(values);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CreateProductWizard
      form={form}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
    />
  );
}
